<template>
  <div id="institute" class="index" v-cloak>
    <!-- 头部 -->
    <Header/>
    <!-- 轮播图 -->
    <div class="carousel is_carousel">
      <el-carousel :loop="false" :autoplay="false">
        <el-carousel-item v-for="(item, index) in instituteList" :key="index">
          <div class="cs_contain" :style='{ backgroundImage : "url(" + item.url + ")" }'>
            <div class="content-width">
              <div :class="['cs_word', index === 0 ? 'cs_word_white' : '']">
                <div v-cloak v-if="item.title1" class="title1">{{item.title1}}</div>
                <div v-cloak class="title2">{{item.title2}}</div>
                <div v-cloak class="remark">{{item.remark}}</div>
              </div>
              <el-button type="primary" round class="use_btn" @click="useClick">申请试用</el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 智慧农业学院 -->
    <div class="zh_institute" id="ist1">
      <div class="content content-title">
        <div class="title">智慧农业学院</div>
        <div class="remark">助力生鲜企业打造标准化、流程化、智能化运营体系</div>
        <ul>
          <li>
            <img class="pic" src="@/assets/img/institute/pic/is1.jpg" />
            <div class="is_title">农学讲堂</div>
            <div class="is_remark">宣讲中央有关农业农村工作的政策、农业科学新技术，并围绕作物的栽培、育种、土壤、气象、肥料、农业病虫害等对农村生产的影响及保障重要农产品有效供给等问题展开讲解。</div>
          </li>
          <li>
            <img class="pic" src="@/assets/img/institute/pic/is2.jpg" />
            <div class="is_title">农业职业经理人培训</div>
            <div class="is_remark">促进其职业道德、职业素养的自我养成，积累企业经营管理知识储备，提升涉农经济组织经营管理能力，促进涉农经济组织发展，提高就业能力。</div>
          </li>
          <li>
            <img class="pic" src="@/assets/img/institute/pic/is3.jpg" />
            <div class="is_title">农业信息化应用培训</div>
            <div class="is_remark">利用先进的互联网、物联网、智能手机等技术，实现农业生产过程中的数据统计、视频监控、灾害预警、农情信息传播等功能，推进农民增收、农业增效、农村发展的实现。</div>
          </li>
          <li>
            <img class="pic" src="@/assets/img/institute/pic/is4.jpg" />
            <div class="is_title">企业管理培训</div>
            <div class="is_remark">组织相关机构、名师及人员定期进行线上、线下培训，发展企业人才储备，增强企业核心竞争力，促进企业发展战略的实施。</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 研究院资讯 -->
    <div class="info zhInfo" id="ist2">
      <div class="content content-title">
        <div class="title">智慧资讯</div>
        <div class="remark">时刻为您提供智慧农业最新资讯和产品动态</div>
        <div class="infoList">
          <div class="sonItem" v-for="(item, index) in newsList" :key="index" @click="getInfo(2, item.id)">
            <img v-if="item.isNew" class="isNew" src="@/assets/img/institute/icon/new.svg" />
            <img class="info_img" :src="item.picture || 'img/index/pic/info.jpg'" />
            <div class="info_title ellipsis">{{item.title}}</div>
            <div class="ellipsis info_remark">{{item.description}}</div>
            <div class="num">
              <span class="l"><img src="@/assets/img/institute/icon/time.svg" />{{item.publishTime}}</span>
              <span class="r"><img src="@/assets/img/institute/icon/see.svg" />{{item.pageviews}}</span>
            </div>
            <!-- <div class="icons">
              <div class="l">
                <div class="li" @click.stop="share_wx()">
                  <img class="push_icon" src="@/assets/img/index/icon/information_1weixin.svg" />
                </div>
                <div class="li" @click.stop="share_wx()">
                  <img class="push_icon" src="@/assets/img/index/icon/information_2pengyouquan.svg" />
                </div>
                <div class="li" @click.stop="share('qzone', item.title, item.description)">
                  <img class="push_icon" src="@/assets/img/index/icon/information_3QQkongjian.svg" />
                </div>
                <div class="li" @click.stop="share('sina', item.title, item.description)">
                  <img class="push_icon" src="@/assets/img/index/icon/information_4weibo.svg" />
                </div>
              </div>
              <img class="r" src="@/assets/img/index/icon/information_5more.svg" />
            </div> -->
          </div>
        </div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[8]" :page-size="8" layout="total, sizes, prev, pager, next, jumper"
          :total="newsTotal">
        </el-pagination>
      </div>
    </div>

    <!-- 更新公告 -->
    <div class="notice">
      <div class="content content-title">
        <div class="title">更新公告</div>
        <div class="remark">实时更新公司最新动态，了解我司发展动向</div>
        <div class="ul">
          <div :class="['li', currentPageNotice === 1? 'normal_li' : '']" v-for="(item, index) in noticeList"
            :key="index">
            <div v-if="index === 0 && currentPageNotice === 1" @click="getInfo(1, item.id)" class="firstNotice"
              :style='{ backgroundImage : "url(" + item.picture + ")" }'>
              <div class="first_bg">
                <div class="m_title ellipsis">{{item.title}}</div>
                <div class="m_remark ellipsis">{{item.description}}</div>
              </div>
            </div>
            <div v-else class="card" @click="getInfo(1, item.id)">
              <img v-if="item.isNew" class="isNew" src="@/assets/img/institute/icon/new.svg" />
              <div class="c_title ellipsis">{{item.title}}</div>
              <div class="c_remark ellipsis">{{item.description}}</div>
              <div class="line"></div> <!-- 分割线 -->
              <div class="month">{{substrMonth(item.publishTime)}}</div>
              <div class="c_b">
                <div class="c_b_l">{{substrYearMonth(item.publishTime)}}</div>
                <img class="c_b_r" src="@/assets/img/index/icon/information_5more.svg" />
              </div>
            </div>
          </div>
        </div>
        <div class="zhInfo n_page">
          <el-pagination background @size-change="handleSizeNotice" @current-change="handleCurrentNotice"
            :current-page="currentPageNotice" :page-sizes="noticeSizes" :page-size="noticeSize"
            layout="total, sizes, prev, pager, next, jumper" :total="noticeTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 客服 -->
    <CustCare />
    <!-- 申请 -->
    <Apply ref="applyRef" />
    <!-- 页面申请 -->
    <ApplyIndex />
    <!-- 联系 -->
    <Contact />
    <!-- 尾部 -->
    <Footer />

  </div>

<!--  <div class="bdsharebuttonbox" style="display:none;">-->
<!--    <xx style="float: left; font-size: 12px;line-height:30px;"> </xx>-->
<!--    <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信" id="wx_share"></a>-->
<!--  </div>-->
</template>
<script>
  import axios from "axios";
  import Header from '@/views/pc/components/header'
  import Contact from '@/views/pc/components/contact'
  import CustCare from '@/views/pc/components/custCare'
  import Footer from '@/views/pc/components/footer'
  import Apply from '@/views/pc/components/apply'
  import ApplyIndex from '@/views/pc/components/applyIndex'
  import { formatDate } from '@/utils/dateFormat'
  export default {
    name: "Institute",
    components: { Header, Contact, CustCare, Footer, Apply, ApplyIndex },
    data () {
      return {
        // 研究院轮播图
        instituteList: [
          {
            title1: '智慧农业学院',
            title2: '赋能生鲜企业管理',
            remark: '帮助生鲜企业通过精益化管理降本增效',
            url: require('@/assets/img/institute/pic/institute.jpg')
          }
        ],
        // 新闻第几页
        currentPage: 1,
        newsTotal: 0,
        currentPageNotice: 1,
        noticeTotal: 0,
        noticeSizes: [8],
        noticeSize: 8,
        // 最新资讯列表
        newsList: [],
        // 公告列表
        noticeList: [],
        baseUrl: this.$baseUrl,
      }
    },
    created () {
      this.getNewsList(1) // 新闻
      this.getNoticesList(1) // 公告
      //创建时执行跳转锚点位置
      this.$nextTick(() => {
        this.getLocal();
      });
    },
    //离开页面进行对localStorage  id销毁，避免其他入口进来有锚点问题
    destroyed() {
      sessionStorage.setItem("ist1", "");
      sessionStorage.setItem("ist2", "");
      sessionStorage.setItem("ist3", "");
    },
    methods: {
      getLocal() {
        //找到锚点id
        const selectId1 = sessionStorage.getItem("ist1");
        const selectId2 = sessionStorage.getItem("ist2");
        const selectId3 = sessionStorage.getItem("ist3");
        //如果对应id存在，就跳转
        if (selectId1) {
          document.getElementById(selectId1).scrollIntoView(true)
        }
        if (selectId2) {
          document.getElementById(selectId2).scrollIntoView(true)
        }
        if (selectId3) {
          document.getElementById(selectId3).scrollIntoView(true)
        }
      },
      // 试用
      useClick() {
        this.applyVisible = true
        this.closeApply()
      },
      // 新闻
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      // 新闻输入页面
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getNewsList(val)
      },
      // 获取月份
      substrMonth(val){
        if (val) {
          return val.substring(8,10)
        }
      },
      // 获取年月
      substrYearMonth(val){
        if (val) {
          return val.substring(0,7)
        }
      },
      // 新闻公告详情跳转
      getInfo(type, id){
        this.$router.push({name:'InstituteInfo',query:{type:type, id:id}});
      },
      // 新闻type2 列表
      getNewsList (pageNum) {
        let that = this
        let _data = {
          pageNum: pageNum,
          type: 2,
          pageSize: 8,
          systemType: 1,
        }
        that.newsList = []
        const url = that.baseUrl + "/message/news/list"
        axios.get(url, { params: _data }).then(res=>{
          let list = res.data
          if (list.newsMap) {
            that.newsList = list.newsMap.rows
            that.newsTotal = list.newsMap.total
          }
        })
      },
      // 公告type1 列表
      getNoticesList (pageNum) {
        let that = this
        let _data = {
          pageNum: pageNum,
          type: 1,
          pageSize: 8,
          systemType: 1,
        }
        that.noticeList = []
        let url = that.baseUrl + "/message/news/list"
        axios.get(url, { params: _data }).then(res=>{
          const list = res.data
          if (list.newsMap) {
            that.noticeList = list.newsMap.rows.map( (e) => {
              e.publishTime = formatDate(e.publishTime)
              return e
            })
            that.noticeTotal = list.newsMap.total
          }
        })
      },
      // 公告
      handleSizeNotice(val) {
        console.log(`每页 ${val} 条`);
      },
      // 公告输入页面
      handleCurrentNotice(val){
        console.log(`当前页: ${val}`);
        this.currentPageNotice = val
        if (val === 1) {
          this.noticeSizes = [8],
            this.noticeSize = 8
        } else {
          this.noticeSizes = [9],
            this.noticeSize = 9
        }
        this.getNoticesList(val)
      }
    }
  }
</script>
<style lang="scss">
@import '@/styles/pc/common/index.scss';
</style>
<style lang="scss" scoped>
@import "@/styles/pc/carousel/index.scss";
@import '@/styles/pc/institute/index.scss';
</style>



// WEBPACK FOOTER //
// src/views/pc/institute.vue